import spiral from '../elements/spiral.js';
spiral.register();
